import React, { useEffect } from 'react';
import { useCreateStartBotPromoterByType } from '../../../editor/features/startBotPromoters/common/use-create-start-bot-promoter-by-type';

type Props = {
  botId: number;
};

const CreateRemoteCustomerChat = (props: Props) => {
  const { botId } = props;
  const createStartBotPromoter =
    useCreateStartBotPromoterByType('customer_chat');

  useEffect(() => {
    createStartBotPromoter();
  }, [botId]);
  return <div />;
};

export default CreateRemoteCustomerChat;
